import React from 'react';

const PROMPTS = [
  { label: 'งูใหญ่', value: 'งูใหญ่' },
  { label: 'ฝันเห็นพระ', value: 'ฝันเห็นพระ' },
  { label: 'น้ำท่วม', value: 'น้ำท่วม' },
  { label: 'เช็คเลข 65', value: '65' },
  { label: 'ฝันเห็นช้าง', value: 'ฝันเห็นช้าง' },
  { label: 'ฝันเห็นทอง', value: 'ฝันเห็นทอง' },
];

export default function QuickPrompts({ onSelect }) {
  return (
    <div className="quick-prompts" aria-label="คำค้นยอดนิยม">
      <p className="quick-prompts__label">ลองคำค้นยอดนิยม</p>
      <div className="quick-prompts__list">
        {PROMPTS.map((p) => (
          <button
            key={p.value}
            type="button"
            className="quick-prompts__chip"
            onClick={() => onSelect(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
